import { useRouter } from 'next/router'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { Layout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'

export const CookieManagementPage = () => {
  const router = useRouter()

  const declineCookie = () => {
    document.cookie = `cookieAccept=false; max-age=31536000; path=/;`
    router.push('/en/')
  }

  return (
    <>
      <Head title="Cookie" description="" noindex />
      <CustomLayout>
        <Layout>
          <Content>
            <StyledButton onClick={declineCookie}>
              Stop using cookies
            </StyledButton>
          </Content>
        </Layout>
      </CustomLayout>
    </>
  )
}

const CustomLayout = styled.div`
  > footer {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
`

const Content = styled.div`
  margin: 80px auto 0;
  width: 1040px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 0 20px;
  }
`

const StyledButton = styled.button`
  color: ${theme.colors.trialBlue};
  background: none;
  border: none;
  font-size: 16px;
  text-decoration: underline;

  &:hover {
    color: ${theme.colors.hoverLightBlue};
  }
`
